module.exports = __webpack_public_path__ + "static/media/950x350-ucla-blue-solid-color-background.03c68006.jpg";